import React, { useCallback, useEffect, useState } from "react";
import ProcessLayout from "../Common/ProcessLayout";
import AudioFilesToProcess from "./TranscriptionComponents/AudioFilesToProcess";
import TranscriptionProcess from "./TranscriptionComponents/TranscriptionProcess";
import TranscriptionProcessLogs from "./TranscriptionComponents/TranscriptionProcessLogs";
import TranscriptionFilewiseStatusLogs from "./TranscriptionComponents/TranscriptionFilewiseStatusLogs";
import { API_URL } from "../../imports";
import axios from "axios";
import Popup from "../Common/Popup";
import { handleApiError } from "../Common/APIUtils";

function Transcription() {
    const [startProcess, setStartProcess] = useState(false);
    const [backgroundProcess, setBackgroundProcess] = useState(false);
    const [filesData, setFilesData] = useState([]);
    const [fetchedFilesData, setFetchedFilesData] = useState([]);
    const [logsData, setLogsData] = useState([]);
    const [processedFiles, setProcessedFiles] = useState([]);
    const [unprocessedFiles, setUnProcessedFiles] = useState([]);
    const [serverStatus, setServerStatus] = useState(false);
    const [serviceUrl, setServiceUrl] = useState("");
    const [serverLoadState, setServerLoadState] = useState(true);
    const [Loader, setLoader] = useState(true);
    const [processOption, setProcessOption] = useState("normal");
    const [serverOFF, setServerOFF] = useState(false);
    const [startIndex, setStartIndex] = useState(undefined);
    const [endIndex, setEndIndex] = useState(undefined);
    const [rowSelection, setRowSelection] = useState({});
    const [fslstartIndex, setfslStartIndex] = useState(undefined);
    const [fslendIndex, setfslEndIndex] = useState(undefined);
    const [fslrowSelection, setfslRowSelection] = useState({});
    
    let [isOpenPopup, setIsOpenPopup] = useState(false);
    let [msg, setMsg] = useState(false);
    let [isSuccess, setIsSuccess] = useState(false);

    function closePopup() {
        setIsOpenPopup(false);
    }

    const openPopup = useCallback(() => {
        setIsOpenPopup(true);
    }, [setIsOpenPopup]);

    const handleStartProcess = async (data) => {
        if (processOption === "normal") {
            setStartProcess(true);

            const initialFiles = data.map((file) => {
                return { ...file, status: null, last_modified: "" };
            });

            setFilesData(initialFiles);
            setLogsData([]);

            const currentLogs = [];

            const updatedProcessedFiles = [];
            const updatedUnprocessedFiles = [];

            let formattedStartDateTime = () => {
                const date = new Date();
                const formattedDateString = date
                    .toLocaleString("en-US", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                    })
                    .replace(/\//g, "/")
                    .replace(",", " ");
                const [month, day, yearAndTime] =
                    formattedDateString.split("/");
                return `${day}-${month}-${yearAndTime}`;
            };

            for (let i = 0; i < data.length; i++) {
                let startdt = formattedStartDateTime();
                let file = data[i];
                file.status = "Inprogress";
                file.start_date_time = startdt;
                file.last_modified = "";
                setFilesData((prevData) => {
                    const newData = [...prevData];
                    newData[i] = file;
                    return newData;
                });
                try {
                    const response = await axios.post(
                        `${API_URL}/Transcription/transcribe/${sessionStorage.getItem(
                            "projectCode"
                        )}`,
                        {
                            filepath: `${sessionStorage.getItem(
                                "projectCode"
                            )}/${file.name}`,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    "access_token"
                                )}`,
                            },
                        }
                    );
                    if (
                        response.data.transcription_entry.status === "success"
                    ) {
                        file.status = "success";
                        file.response =
                            response.data.transcription_entry.response;
                        const date = new Date();
                        file.last_modified = date;
                        file.transcription_model =
                            response.data.transcription_entry.transcription_model;
                        // file.start_date_time = response.data?.logs?.start_date_time || startdt;
                        currentLogs.push({
                            creation_date: date,
                            ...response.data.logs,
                        });
                        updatedProcessedFiles.push(file);
                    } else {
                        file.status = "error";
                        file.response = null;
                        const errordate = new Date();
                        file.last_modified = errordate;
                        file.transcription_model =
                            response.data?.logs?.transcription_model || "";
                        // file.start_date_time = response.data?.logs?.start_date_time || startdt;
                        currentLogs.push({
                            creation_date: errordate,
                            ...response.data.logs,
                        });
                        updatedUnprocessedFiles.push(file);
                    }
                } catch (error) {
                    // Update the status of the current file to "error"
                    file.status = "error";
                    file.response = null;
                    const errordate = new Date();
                    file.last_modified = errordate;
                    file.transcription_model =
                        error.response?.data?.logs?.transcription_model || "";
                    // file.start_date_time = error.response.data?.logs?.start_date_time || startdt;
                    const errorMessage = handleApiError(error);
                    if (errorMessage !== "CoreAPIError") {
                        currentLogs.push({
                            filename: file.name,
                            creation_date: errordate,
                        });
                        setMsg(errorMessage);
                        setIsSuccess(false);
                        if (data.length === 1) {
                            openPopup();
                        }
                    } else {
                        currentLogs.push({
                            creation_date: errordate,
                            filename: file.name,
                            ...error.response.data.logs,
                        });
                    }
                    updatedUnprocessedFiles.push(file); // Add to unprocessedFiles
                }
                setFilesData((prevData) => {
                    const newData = [...prevData];
                    newData[i] = file;
                    return newData;
                });
            }

            // Update the state with the updatedFiles array
            setLogsData(currentLogs);
            setProcessedFiles(updatedProcessedFiles); // Update processedFiles state
            setUnProcessedFiles(updatedUnprocessedFiles); // Update unprocessedFiles state
            setStartProcess(false);
        } else {
            // code for background process
            setBackgroundProcess(true);
            const fileNames = data.map((file) => file.name);
            try {
                const response = await axios.post(
                    `${API_URL}/Transcription/background/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        files: fileNames,
                        serverState: serverOFF
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                    }
                );
                if (response) {
                    setMsg(response.data.message);
                    setServerStatus(response.data.serverStatus);
                    setIsSuccess(true);
                    openPopup();
                }
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            }
            setBackgroundProcess(false);
            ReloadData();
        }
    };

    const fetchBatchAudioData = async (batch_no) => {
        try {
            const response = await axios.get(
                `${API_URL}/Transcription/getfilelist/${sessionStorage.getItem(
                    "projectCode"
                )}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "access_token"
                        )}`,
                    },
                    params: {
                        batch: batch_no || null,
                    },
                }
            );
            setFetchedFilesData(response.data.data);
        } catch (error) {
            const errorMessage = handleApiError(error);
            setMsg(errorMessage);
            setIsSuccess(false);
            openPopup();
        } finally {
            setTimeout(() => {
                setLoader(false);
            }, 100);
        }
    };
    useEffect(() => {
        const fetchAudioData = async () => {
            try {
                const response = await axios.get(
                    `${API_URL}/Transcription/getfilelist/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                        params: {
                            batch: sessionStorage.getItem("batch") || null,
                        },
                    }
                );
                setFetchedFilesData(response.data.data);
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            } finally {
                setTimeout(() => {
                    setLoader(false);
                }, 100);
            }
        };
        const fetchStatus = async () => {
            try {
                const response = await axios.get(`${API_URL}/instancemonitor`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "access_token"
                        )}`,
                    },
                    params: {
                        server_instance: "GPU",
                    },
                });
                if (response) {
                    setServerStatus(response.data.data[0].serverStatus);
                    setServiceUrl(response.data.data[0].service_url);
                }
            } catch (error) {
                const errorMessage = handleApiError(error);
                if (errorMessage) {
                    setServerStatus(false);
                    setServiceUrl("");
                }
            } finally {
                setServerLoadState(false);
            }
        };
        fetchAudioData();
        fetchStatus();
    }, [setFetchedFilesData, setServerStatus, openPopup]);

    const ReloadData = useCallback(() => {
        setLoader(true);
        setRowSelection({});
        setStartIndex(undefined);
        setEndIndex(undefined);
        const reloadAudioData = async () => {
            try {
                const batch_no = sessionStorage.getItem("batch");
                const response = await axios.get(
                    `${API_URL}/Transcription/getfilelist/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                        params: {
                            // batch: sessionStorage.getItem("batch") || null,
                            batch: batch_no || null,
                        },
                    }
                );
                setFetchedFilesData(response.data.data);
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            } finally {
                setTimeout(() => {
                    setLoader(false);
                }, 100);
            }
        };
        reloadAudioData();
    }, [setFetchedFilesData, openPopup]);

    const tabs = [
        {
            id: 1,
            title: "Audio Files",
            content: (
                <AudioFilesToProcess
                    serverStatus={serverStatus}
                    ReloadData={ReloadData}
                    items={fetchedFilesData}
                    startProcess={startProcess}
                    backgroundProcess={backgroundProcess}
                    setFilesData={handleStartProcess}
                    Loader={Loader}
                    setProcessOption={setProcessOption}
                    setServerOFF={setServerOFF}
                    startIndex={startIndex}
                    endIndex={endIndex}
                    setStartIndex={setStartIndex}
                    setEndIndex={setEndIndex}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                />
            ),
        },
        {
            id: 2,
            title: "Transcription Process",
            content: (
                <TranscriptionProcess
                    startProcess={startProcess}
                    selectedFilesToProcess={filesData}
                />
            ),
        },
        {
            id: 3,
            title: "Logs",
            content: (
                <TranscriptionProcessLogs
                    logs={logsData}
                    processedfiles={processedFiles}
                    unprocessedfiles={unprocessedFiles}
                />
            ),
        },
        {
            id: 4,
            title: "All Files Status",
            content: <TranscriptionFilewiseStatusLogs 
                        startIndex={fslstartIndex}
                        endIndex={fslendIndex}
                        setStartIndex={setfslStartIndex}
                        setEndIndex={setfslEndIndex}
                        rowSelection={fslrowSelection}
                        setRowSelection={setfslRowSelection}
                    />,
        },
    ];

    return (
        <>
            <Popup
                isOpen={isOpenPopup}
                msg={msg}
                closeModal={closePopup}
                isSuccess={isSuccess}
            />
            <ProcessLayout
                startProcess={startProcess}
                tabs={tabs}
                server="Transcription Service"
                serverStatus={serverStatus}
                serviceUrl={serviceUrl}
                serverLoadState={serverLoadState}
                batching={true}
                handleBatchChange={fetchBatchAudioData}
            />
        </>
    );
}

export default Transcription;
